import * as React from "react";

const IconPaginationBannerLeftHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 85"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><g fill="none" fillRule="evenodd"><path fill="#298CF0" d="M0 0h42v85H0z"/><path fill="#FFF" fillRule="nonzero" d="M12.961 43.164l-.664-.664.664-.664 6-6 .664-.664 1.324 1.324-.664.664-4.398 4.403H29.75v1.875H15.887l4.402 4.398.664.664-1.324 1.324-.664-.664z"/></g></svg>;
};

export default React.memo(IconPaginationBannerLeftHover);
